// Config, defaults, and constants for the multi-step questionnaire.
// Extracted from QuestionnairePage.jsx during the Feb 2026 refactor.

export const getDefaultFormData = () => ({
  // Personal
  age: 35,
  occupation: "",
  dependents: 0,
  
  // Duration & Lifestyle
  intended_duration: "permanent",
  alcohol_habits: "social",
  cannabis_habits: "none",
  
  // Family
  has_school_children: false,
  children_ages: "",
  bringing_elderly: false,
  elderly_care_needs: "",
  
  // Health & Lifestyle
  health_conditions: [],
  hobbies: [],
  other_hobby: "",
  
  // Languages
  languages: ["English"],
  other_language: "",
  
  // Financial
  financial_resources: "medium",
  income_sources: [],
  target_monthly_budget: "",
  
  // Work & Internet
  intend_to_work: false,
  work_type: "remote",
  require_high_speed_internet: false,
  internet_speed_requirement: "50",
  
  // Safety Preferences
  low_crime_importance: 3,
  government_stability_importance: 3,
  low_natural_disaster_risk: false,
  travel_ease_importance: 3,
  healthcare_importance: 3,
  expat_community_importance: 3,
  
  // Climate & Environment (now arrays for multi-select)
  climate_preferences: ["temperate"],
  weather_preferences: ["mild"],
  city_preferences: ["urban"],
  
  // Additional Options
  compare_specific_country: false,
  specific_countries: [],
  other_country: "",
  solve_for_budget: false,
  budget_amount: "",
  
  // Final Thoughts
  additional_info: ""
});

export const STEPS = [
  { id: "personal", title: "Personal Info", description: "Tell us about yourself" },
  { id: "duration", title: "Duration & Lifestyle", description: "Your relocation plans" },
  { id: "family", title: "Family Situation", description: "Your family needs" },
  { id: "health", title: "Health & Lifestyle", description: "Your health and hobbies" },
  { id: "languages", title: "Languages", description: "Languages you speak" },
  { id: "financial", title: "Financial", description: "Your financial situation" },
  { id: "work", title: "Work & Internet", description: "Employment and connectivity" },
  { id: "preferences", title: "Safety & Stability", description: "What matters most to you" },
  { id: "climate", title: "Climate & Environment", description: "Your ideal environment" },
  { id: "options", title: "Additional Options", description: "Customize your search" },
  { id: "additional", title: "Final Thoughts", description: "Any other considerations" }
];

export const HEALTH_CONDITIONS = [
  "None", "Chronic illness", "Mobility issues", "Requires regular medication",
  "Mental health support needed", "Allergies", "Dietary restrictions"
];

export const HOBBIES = [
  "Outdoor sports", "Beach activities", "Hiking/Nature", "Golf", "Tennis",
  "Arts & Culture", "Nightlife", "Fine dining", "Remote work", "Volunteering"
];

export const LANGUAGES = [
  "English", "Spanish", "French", "German", "Portuguese", "Italian",
  "Mandarin", "Japanese", "Arabic", "Russian", "Dutch", "Thai"
];

export const INCOME_SOURCES = [
  "Employment income", "Remote work", "Retirement/Pension", "Investments",
  "Rental income", "Business ownership", "Freelance/Contract"
];

export const WEATHER_PREFERENCES = [
  { value: "sunny", label: "Mostly Sunny", desc: "300+ sunny days/year" },
  { value: "mild", label: "Mild Year-Round", desc: "Comfortable temperatures" },
  { value: "seasonal", label: "Distinct Seasons", desc: "Enjoy variety" },
  { value: "rainy", label: "Don't Mind Rain", desc: "Green landscapes" }
];

export const COUNTRIES_LIST = [
  "Portugal", "Spain", "Costa Rica", "Mexico", "Thailand", "Panama", "Ecuador",
  "Malaysia", "Colombia", "Vietnam", "France", "Germany", "Canada", "Netherlands",
  "New Zealand", "Australia", "Japan", "Singapore", "Italy", "Greece", "Croatia",
  "Uruguay", "Argentina", "Chile", "Philippines", "Indonesia", "Ireland", "UK"
];
